import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuToggleOption} from '@Components/contextual-menu/components/contextual-menu-toggle-option';
import {useAppSelector} from '@/hooks';
import {updateAreAlignmentGuidesEnabled} from '@/reducers/user-preferences.reducer';

export function PageAlignmentGuidesOptions(): ReactElement<any> | null {
  const areAlignmentGuidesEnabled = useAppSelector((state) => {
    return state.userPreferences.areAlignmentGuidesEnabled;
  });
  const areAlignmentGuidesPreferenceUpdating = useAppSelector((state) => {
    return state.userPreferences.areAlignmentGuidesPreferenceUpdating;
  });

  if (areAlignmentGuidesEnabled === undefined) {
    return null;
  }

  return (
    <ContextualMenuToggleOption
      id="page-alignment-guides-option"
      label={window.i18next.t('pmwjs_alignment_guides')}
      isLoading={areAlignmentGuidesPreferenceUpdating}
      isChecked={areAlignmentGuidesEnabled}
      onClick={(): void => {
        void updateAreAlignmentGuidesEnabled(!areAlignmentGuidesEnabled);
      }}
    ></ContextualMenuToggleOption>
  );
}
